import { GetRowIdParams } from "ag-grid-enterprise";
import { LINKED_ACTIVITIES_COLUMN_FILTER_LABELS } from "../constants";

export const getRowId = (params: GetRowIdParams<{ id: string }>) =>
  params.data.id;

export const backwardCompatibilityForLinkedTasksFilter = (
  sortedColumnConfig: any
) => {
  const linkedTasksColumnConfig = sortedColumnConfig.find(
    (col: any) => col.field.name === "linked_tasks"
  );

  if (linkedTasksColumnConfig && linkedTasksColumnConfig.field.agFilter) {
    const parsedFilter = JSON.parse(linkedTasksColumnConfig.field.agFilter);
    if (
      parsedFilter.values.length === 1 &&
      parsedFilter.values[0] ===
        LINKED_ACTIVITIES_COLUMN_FILTER_LABELS.ACTIVITY_LINKED
    ) {
      parsedFilter.values = [
        LINKED_ACTIVITIES_COLUMN_FILTER_LABELS.CRITICAL,
        LINKED_ACTIVITIES_COLUMN_FILTER_LABELS.NOT_CRITICAL
      ];
    }
    linkedTasksColumnConfig.field.agFilter = JSON.stringify(parsedFilter);
  }
  return sortedColumnConfig;
};
